import React, { useState, useEffect } from 'react';
import { Alert } from '../../services/notiflix.service';
import ProjectsService from '../../services/projects.service';
import { useTranslation } from 'react-i18next';
import ProjectListingRootComponent from '../../components/common/projectListing/ProjectListingRootComponent';
const ProjectList = () => {
  const [projectLists, setProjectList] = useState([]);
  const [selectedOption, selectOptions] = useState('new_to_old');
  const [projectLoading, setProjectLoading] = useState(true);
  const [isSortingLoader, setSortingLoader] = useState(false);
  const [isPagination, setPagination] = useState({
    totalPages: 5,
    currentPage: 1,
  });

  const [isView, setView] = useState(1);
  const { t } = useTranslation(['projectList', 'common', 'assets']);
  const [filterData, setFilterData] = useState({
    perPage: 10,
    page: 1,
    commonSearch: '',
    sortBy: 'new_to_old',
    investmentType: '',
  });
  const [isDropDownList, setIsDropDownList] = useState([]);
  useEffect(() => {}, [t]);
  useEffect(() => {
    setIsDropDownList([
      {
        name: t('new_to_old'),
        value: 'new_to_old',
      },
      {
        name: t('old_to_new'),
        value: 'old_to_new',
      },
      {
        name: t('low_to_high_cost'),
        value: 'low_to_high',
      },
      {
        name: t('high_to_low_cost'),
        value: 'high_to_low',
      },
    ]);
  }, [t]);
  useEffect(() => {
    projectsList();
  }, [filterData]);
  const projectsList = async (
    pagination = { currentPage: 1 },
    sorting = { field: '', order: '' },
    isSorting = false,
  ) => {
    try {
      if (isSorting) {
        setSortingLoader(true); // Show sorting loader
      } else {
        setProjectLoading(true); // Show pagination loader
      }
      const { currentPage } = pagination;
      const { field, order } = sorting;
      let projectListRes = await ProjectsService.list(
        filterData.perPage,
        currentPage,
        filterData.commonSearch,
        filterData.sortBy,
        filterData.investmentType,
        field,
        order,
      );
      if (projectListRes.status === 'failure') {
        setProjectLoading(false);
        Alert.error(projectListRes.message);
        return false;
      }
      setProjectLoading(false);
      setProjectList(projectListRes?.data?.records);
      setPagination({
        totalPages: projectListRes.data.pagination.totalPages,
        currentPage: projectListRes.data.pagination.page,
      });
    } catch (error) {
      setProjectLoading(false);
      Alert.error(error.message);
      return false;
    }
  };

  const searchData = async (_action, _value) => {
    if (_action === 'investmentType' && _value === filterData.investmentType)
      return false;
    selectOptions(_value);
    setFilterData({
      ...filterData,
      page: 1,
      [_action]: _value,
    });
  };

  return (
    <>
      <div className="">
        <div>
          <div className="md:py-5 md:pl-5">
            <div className=" text-center my-24 md:dark:text-slate-200">
              <h2>{t('assets:explore_new_opportunities')}</h2>
              <p className="mt-2">
                {t('assets:discover_compare_purchase_projects')}
              </p>
            </div>
            <ProjectListingRootComponent
              headerText={t('common:all_projects')}
              projectLists={projectLists}
              message={t('common:no_data_found')}
              slug={'assets'}
              projectLoading={projectLoading}
              count={4}
              searchData={searchData}
              filterData={filterData}
              isDropDownList={isDropDownList}
              value={selectedOption}
              isView={isView}
              setView={setView}
              isSortingLoader={isSortingLoader}
              list={projectsList}
              isPagination={isPagination}
              setPagination={setPagination}
              isListLoader={projectLoading}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectList;
